import { render, staticRenderFns } from "./dataCount.vue?vue&type=template&id=55351080&scoped=true"
import script from "./dataCount.vue?vue&type=script&lang=js"
export * from "./dataCount.vue?vue&type=script&lang=js"
import style0 from "./dataCount.vue?vue&type=style&index=0&id=55351080&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55351080",
  null
  
)

export default component.exports